import { SortOrderType } from '@cupoui/shared/model/enumerations/sort-order-type.model';
import { CasesFilter } from './cases-filter.model';

export class CaseFilterRequest {
  sortBy: string;
  userId: string;
  teamId: string;
  pageSize: number;
  pageIndex: number;
  totalCases: number;
  sortOrder: SortOrderType;
  filter: CasesFilter;

  public constructor(init?: Partial<CaseFilterRequest>) {
    Object.assign(this, init);
  }
}
